import React from "react";
import {PersonalizationContext} from "./personalization-provider";

export const withPersonalizationData =
  (InnerComponent: React.ElementType) => (props: any) =>
    (
      <PersonalizationContext.Consumer>
        {(consumerState) => (
          <InnerComponent personalizationData={consumerState} {...props} />
        )}
      </PersonalizationContext.Consumer>
    );
